/* eslint-disable jsx-a11y/control-has-associated-label */
/** @jsx jsx */
import { jsx } from '@emotion/react';
import styled from '@emotion/styled';
import { onMd, onSm } from '../../styles/responsive';
import { colors, transitions } from '../../theme';
import { BorderedButton } from '../Buttons/BorderedButton';

export const HeaderNavigation = styled(({ className, links }: { links: any[]; className?: string }) => {
  return (
    <nav css={{ display: 'flex', padding: '8px' }}>
      <ul className={className}>
        {links
          ? links.map((link, key) => {
              const openRule = link.external ? '_blank' : '_self';
              if (link.link !== '' && link.text !== '') {
                return (
                  <li key={key}>
                    <a
                      css={{ textDecoration: 'none' }}
                      href={link.link}
                      target={openRule}
                      rel="noopener"
                      dangerouslySetInnerHTML={{ __html: link.text }}
                    />
                  </li>
                );
              }
              return null;
            })
          : null}
        <li key="chat-with-us-btn">
          <BorderedButton
            rootCss={{
              [onMd]: {
                marginLeft: '10px'
              }
            }}
            text="Chat with us"
            onClick={() => {
              (window as any).Tawk_API.showWidget();
              setTimeout(() => {
                (window as any).Tawk_API.toggle();
              });
            }}
          />
        </li>
      </ul>
    </nav>
  );
})`
  display: flex;
  align-items: center;
  -webkit-overflow-scrolling: touch;
  float: left;
  ${onMd} {
    padding-left: 25px;
  }
  ${onSm} {
    width: 100%;
    justify-content: space-evenly;
    flex-wrap: wrap;
    vertical-align: middle;
    li {
      a {
        font-size: 14px;
        padding: 10px 15px;
      }
    }
  }
  li {
    list-style-type: none;
    display: flex;
    & > a:before {
      content: '';
      position: absolute;
      width: 100%;
      height: 3px;
      bottom: 0;
      left: 0;
      visibility: hidden;
      border-radius: 4px;
    }
    a {
      font-family: 'Roboto';
      position: relative;
      color: ${colors.font};
      font-size: 14px;
      font-weight: 500;
      line-height: 1em;
      opacity: 1;
      padding: 5px 12px;
      &:hover {
        transition: ${transitions.hover};
        color: ${colors.primary};
      }
    }
  }
`;
